import React, { useMemo } from 'react';
import type { PreparedGlassArtwork } from '../../assets/prepareGlassArtwork';
import type { GlassDesign } from '../../assets/glassCatalogue';
import type { GlazingSlot } from '../../assets/glazingSlots';

const OBJECT_BOUNDING_BOX_CLIP = 'objectBoundingBox';

function glazingClipDefs(slots: GlazingSlot[], clipUid: string): string {
  return slots
    .map((slot) => {
      const geometry =
        slot.clipMarkup ?? `<rect x="0" y="0" width="1" height="1"/>`;
      return `<clipPath id="${clipUid}-${slot.id}" clipPathUnits="${OBJECT_BOUNDING_BOX_CLIP}">${geometry}</clipPath>`;
    })
    .join('');
}

export const GlazingLayer: React.FC<{
  glassDesign: GlassDesign;
  artwork: PreparedGlassArtwork;
  slots: GlazingSlot[];
  clipUid: string;
}> = ({ glassDesign, artwork, slots, clipUid }) => {
  const clipDefs = useMemo(() => glazingClipDefs(slots, clipUid), [clipUid, slots]);

  if (!artwork.href) return null;

  return (
    <g data-part="door-glazing" data-glass-id={glassDesign.id}>
      <defs dangerouslySetInnerHTML={{ __html: clipDefs }} />
      {slots.map((slot) => (
        <image
          key={`${slot.id}-${glassDesign.id}`}
          data-part="door-glass-slot"
          data-glass-slot={slot.id}
          data-glazing-guide={`glazing-guide-${slot.id.replace(/\D+/g, '')}`}
          href={artwork.href}
          x={slot.x}
          y={slot.y}
          width={slot.width}
          height={slot.height}
          preserveAspectRatio="none"
          clipPath={`url(#${clipUid}-${slot.id})`}
        />
      ))}
    </g>
  );
};
